module.exports = __webpack_public_path__ + "ccafa5848eeab51af6c0a93621e839a9.pdf";